import styled from 'styled-components'

export const StyledAIAssistantContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`
